export enum Currency {
    PLN = 1,
    EURO = 2
}
export enum Currency {
    PLN = 1,
    EURO = 2
}
